import { ConfirmationModal } from "../../../shared/components/common";

const DeleteCaseModal = ({ show, onClose, onDelete, caseData }) => {
  const handleDelete = () => {
    if (caseData) {
      onDelete(caseData.id);
      onClose();
    }
  };

  return (
    <ConfirmationModal
      show={show}
      onCancel={onClose}
      onConfirm={handleDelete}
      title="Delete Support Case"
      messages={[
        `Are you sure you want to delete "${caseData?.title || "this case"}"?`,
        "This action cannot be undone and all conversation history will be lost.",
      ]}
      confirmText="Delete Case"
      cancelText="Cancel"
      confirmColor="error"
      cancelColor="primary"
    />
  );
};

export default DeleteCaseModal;
